/* jf-lazy-video: HLS adaptive streaming + play-in-view for decorative/background videos.
   Markup: <video data-jf-lv="view|eager" data-hls="...m3u8" data-mp4="fallback.mp4" muted loop playsinline preload="none">
   view  = nothing is downloaded until the video is near the viewport; plays muted while visible, pauses when it leaves.
   eager = (hero) streams immediately, no pause logic.
   Same quality: HLS picks the highest level that fits the player size; mp4 is the fallback. */
(function () {
  if (window.__jfLazyVideo) { return; }
  window.__jfLazyVideo = true;
  var HLS_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.20/hls.light.min.js';
  var hlsPromise = null;
  function loadHls() {
    if (window.Hls) { return Promise.resolve(window.Hls); }
    if (!hlsPromise) {
      hlsPromise = new Promise(function (res, rej) {
        var sc = document.createElement('script');
        sc.src = HLS_SRC; sc.async = true;
        sc.onload = function () { res(window.Hls); };
        sc.onerror = rej;
        document.head.appendChild(sc);
      });
    }
    return hlsPromise;
  }
  var nativePlay = HTMLMediaElement.prototype.play;
  var apple = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);

  function attach(v) {
    if (v._jfAttach) { return v._jfAttach; }
    var hls = v.getAttribute('data-hls'), mp4 = v.getAttribute('data-mp4');
    function useMp4() { if (mp4) { v.src = mp4; } }
    v._jfAttach = new Promise(function (resolve) {
      if (hls && apple && v.canPlayType('application/vnd.apple.mpegurl')) { v.src = hls; return resolve(); }
      if (!hls) { useMp4(); return resolve(); }
      loadHls().then(function (Hls) {
        if (Hls && Hls.isSupported()) {
          var h = new Hls({ capLevelToPlayerSize: true, startLevel: -1, abrEwmaDefaultEstimate: 4000000, maxBufferLength: 30, maxMaxBufferLength: 60, backBufferLength: Infinity });
          v._hls = h; h.loadSource(hls); h.attachMedia(v);
          h.on(Hls.Events.ERROR, function (e, d) { if (d.fatal) { h.destroy(); v._hls = null; useMp4(); nativePlay.call(v).catch(function () {}); } });
        } else { useMp4(); }
        resolve();
      }).catch(function () { useMp4(); resolve(); });
    });
    return v._jfAttach;
  }
  function play(v) { return attach(v).then(function () { var p = nativePlay.call(v); return p && p.catch ? p.catch(function () {}) : p; }); }

  function init(v) {
    if (v._jfInit) { return; }
    v._jfInit = true;
    var mode = v.getAttribute('data-jf-lv');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    /* anything else on the page (e.g. theme.js) that calls v.play() before the stream is attached waits for it */
    v.play = function () { return attach(v).then(function () { return nativePlay.call(v); }); };
    v.addEventListener('pause', function () { if (!v._jfAuto) { v._jfUserPaused = true; } v._jfAuto = false; });
    v.addEventListener('play', function () { v._jfUserPaused = false; });
    if (mode === 'eager') { if (!reduce) { play(v); } return; }
    if (reduce || saveData || !('IntersectionObserver' in window)) {
      v.addEventListener('click', function () { play(v); }, { once: true });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { if (!v._jfUserPaused) { play(v); } }
        else if (v._jfAttach && !v.paused) { v._jfAuto = true; v.pause(); }
      });
    }, { rootMargin: '150px 0px', threshold: 0.01 });
    io.observe(v);
  }
  function scan() { [].forEach.call(document.querySelectorAll('video[data-jf-lv]'), init); }
  scan();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); }
  document.addEventListener('shopify:section:load', scan);
})();
